import React, { useState } from 'react';
import '../App.css';

const steps = [
    {
        label: 'Describe something you already like',
        body: (
            <>
                <ul style={{ margin: '0 0 10px 0', paddingLeft: '16px', lineHeight: 2 }}>
                    <li><em>"Underground Resistance - The Final Frontier"</em></li>
                    <li><em>"Cameroonian Funk"</em></li>
                    <li><em>"Early 80s Peter Tosh"</em></li>
                    <li><em>"Late 90s UKG like on Nice N Ripe"</em></li>
                    <li><em>"Bob Marley"</em></li>
                </ul>
                <p style={{ opacity: 0.6, fontSize: '11px' }}>
                    The more specific you are the better, artist, era, style, label, country etc
                </p>
            </>
        ),
    },
    {
        label: '',
        body: (
            <>
                <p style={{ marginBottom: '12px', opacity: 0.6, fontSize: '11px' }}>
                    Hit <strong>dive</strong> to go deeper for any release. Press <strong>back</strong> to go up a level. Explore over 1 billion paths!
                </p>
                <video
                    src="https://storage.googleapis.com/tmhimagebucket/example_dive_usage.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{ width: '100%', borderRadius: '8px', display: 'block' }}
                />
            </>
        ),
    },
];

const ChatWelcomeOverlay = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [step, setStep] = useState(0);

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem('chatWelcomeShown', 'true');
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    const isLast = step === steps.length - 1;

    return (
        <div className="welcome-overlay">
            <div className="welcome-overlay-content">
                <button className="welcome-close-button" onClick={handleClose}>×</button>

                {step === 0 && <h2>Welcome to voyager mode (beta)</h2>}
                {step === 0 && (
                    <p style={{ opacity: 0.5, fontSize: '11px', marginBottom: '12px' }}>
                        Voyager mode is in beta - results may be less precise than direct mode.
                    </p>
                )}

                <div style={{ marginBottom: '20px', opacity: 0.5, fontSize: '11px', letterSpacing: '0.05em' }}>
                    {steps[step].label}
                </div>

                <div style={{ lineHeight: 1.7, marginBottom: '28px' }}>
                    {steps[step].body}
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '6px' }}>
                        {steps.map((_, i) => (
                            <div
                                key={i}
                                style={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    background: i === step ? '#009e4a' : 'rgba(0,158,74,0.25)',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setStep(i)}
                            />
                        ))}
                    </div>
                    <button
                        onClick={isLast ? handleClose : () => setStep(s => s + 1)}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            fontFamily: 'CustomFont',
                            fontSize: '13px',
                            padding: '5px 14px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                        }}
                        onMouseOver={(e) => { e.target.style.background = '#009e4a'; e.target.style.color = 'black'; }}
                        onMouseOut={(e) => { e.target.style.background = 'none'; e.target.style.color = '#009e4a'; }}
                    >
                        {isLast ? 'start diving' : 'next →'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChatWelcomeOverlay;
